import { Stack } from '@chakra-ui/react'
import type { FC, PropsWithChildren } from 'react'
import { createContext, useMemo, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import Drawer from '@app/shared/drawer/drawer'

export const ReportContext = createContext({ containerRef: null })

const ReportsDrawer: FC<PropsWithChildren> = ({ children }) => {
  const containerRef = useRef(null)
  const context = useMemo(() => ({ containerRef }), [containerRef])
  const navigate = useNavigate()

  const onDrawerClose = () => {
    navigate('..')
  }

  return (
    <Drawer onOpenChange={onDrawerClose} open>
      <ReportContext.Provider value={context}>
        <Stack as="section" gap={0} overflow="auto" h="100%" id="lazyload-container">
          {children}
        </Stack>
      </ReportContext.Provider>
    </Drawer>
  )
}

export default ReportsDrawer
